// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const pageSizeSelector = "PageSizeSelector__pageSizeSelector__wOPjO";
export const label = "PageSizeSelector__label__nmdWk font-faces__sansMedium__DqLMY font-faces__sans__uCf65";
export const options = "PageSizeSelector__options__4ywyk";
export const option = "PageSizeSelector__option__KjR+I";
export const current = "PageSizeSelector__current__hezqU";